// extracted by mini-css-extract-plugin
export default {"hint":"styles_hint___sM9H"};